<template>
  <div class="form-panel">
    <p class="form-panel__title"><i class="mdi mdi-filter-variant"></i>Selecione o serviço</p>

    <div class="form-panel__toggles">
      <span>
        Filtrar por 
        <a 
          class="text-link" 
          :style="filterPerDate ? 'font-weight:700;' : 'opacity:0.6;'"
          @click="filterPerDate = true"
        >Data</a> 
        ou 
        <a 
          class="text-link" 
          :style="!filterPerDate ? 'font-weight:700;' : 'opacity:0.6;'"
          @click="filterPerDate = false"
        >Criador</a>
      </span>
    </div>

    <template v-if="filterPerDate">
      <div class="form-panel__field">
        <date-picker 
          label="Data Inicial"
          dense
          :binding.sync="filter.date"
          :readOnly="false"
        />
      </div>
      <div class="form-panel__field">
        <date-picker 
          label="Data Final"
          dense
          :binding.sync="filter.date_end"
          :readOnly="false"
        />
      </div>
    </template>

    <v-autocomplete
      v-else 
      class="form-panel__field"
      outlined
      dense
      label="Selecione o Criador"
      v-model="filter.person_id"
      item-text="name"
      item-value="id"
      :items="creators"
      no-data-text="Nenhum Resultado"
    ></v-autocomplete>

    <v-autocomplete
      v-if="filterPerDate || filter.person_id"
      class="form-panel__field"
      label="Selecione o Serviço"
      outlined
      dense
      no-data-text="Nenhum Resultado"
      :items="computedServices"
      item-text="title"
      item-value="id"
      v-model="filter.service_id"
    ></v-autocomplete>

    <div class="form-panel__actions">
      <v-btn 
        class="success"
        :disabled="!filter.service_id"
        @click="submit"
      >
        <i class="mdi mdi-file-chart-outline pr-1"></i>
        Gerar Relatório
      </v-btn>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/layout/DatePicker";
export default {
  name:"ReportFilters",
  props:{
    creators:Array,
    services:Array
  },
  components:{
    DatePicker
  },
  data() {
    return {
      filter:{},
      filterPerDate:true
    }
  },
  computed: {
    computedServices() {
      if(this.services.length && this.filter.date !== undefined && this.filter.date_end) {
        const unixStartDate = Math.round(new Date(this.filter.date).getTime() / 1000);
        const unixDateEnd = Math.round(new Date(this.filter.date_end).getTime() / 1000);
        const services_validated = this.services.filter(e => e.date !== undefined && e.date !== null);
        return services_validated.filter(e => 
        Math.round(new Date(e.date).getTime() / 1000) >= unixStartDate && 
        Math.round(new Date(e.date).getTime() / 1000) <= unixDateEnd)
        .map(service => ({...service, title:this.parseDate(service.date)}))
      } 
      else if(this.services.length && this.filter.person_id) {
        return this.services.filter(e => e.person.id === this.filter.person_id)
        .map(service => ({...service, title:this.parseDate(service.date)}));
      }
      else {
        return [];
      }
    },
  },
  methods: {
    submit() {
      this.$emit("submit", {service_id:this.filter.service_id});
      this.$emit("update-filter", this.filter);
    },
    parseDate(date) {
      if(date) {
        const [year,month,day] = date.split("-");
        return `${day}/${month}/${year}`
      }
    }
  },
  watch: {
    filterPerDate(val) {
      if(val) {
        delete this.filter?.person_id;
      } else {
        delete this.filter?.date;
        delete this.filter?.date_end;
      }
      delete this.filter?.service_id;
    }
  }
}
</script>